import BaseColor from '@/atoms/colors/Base';
import Size from '@enums/Size';
import { core } from '@/lib/theme/tokens/palettes';
import Chip from './Chip';
import tagColor from './utils/tagColor';

const inactiveColor = (color) => {
  return {
    normal: {
      backgroundColor: core.white,
      boxShadow: `0 0 0 1px ${color.normal.backgroundColor}`,
      color: `${BaseColor.font.primary}bd`,
    },
    focus: {
      backgroundColor: core.white,
      boxShadow: `0 0 0 1px ${color.normal.backgroundColor}`,
      color: `${BaseColor.font.primary}bd`,
    },
    hover: {
      backgroundColor: `${color.normal.backgroundColor}1c`,
      boxShadow: `0 0 0 1px ${color.normal.backgroundColor}`,
      color: BaseColor.font.primary,
    },
  };
};

const TagChip = ({
  color,
  expanded = false,
  isOutline,
  size = Size.SMALL,
  ...props
}) => {
  const selectedColor = tagColor({ color });

  const chipColor = isOutline ? inactiveColor(selectedColor) : selectedColor;

  return (
    <Chip colorProps={chipColor} expanded={expanded} size={size} {...props} />
  );
};

export default TagChip;
